import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "i1977976734__a" }, [
        _createElementVNode("rect", {
          width: "22",
          height: "22",
          rx: "0"
        })
      ])
    ], -1),
    _createElementVNode("g", { "clip-path": "url(#i1977976734__a)" }, [
      _createElementVNode("path", {
        fill: "#FFF",
        d: "M0 22h2.292V0H0v22ZM20.167 0h-16.5v22h16.5A1.839 1.839 0 0 0 22 20.167V1.833A1.839 1.839 0 0 0 20.167 0ZM10.083 5.042c.23 0 .413.046.596.137a2.292 2.292 0 0 1 2.154-1.512c1.009 0 1.834.641 2.155 1.512.183-.091.366-.137.595-.137.78 0 1.375.596 1.375 1.375 0 .596-.366 1.1-.916 1.283v3.758H9.625V7.7a1.335 1.335 0 0 1-.917-1.283c0-.78.596-1.375 1.375-1.375ZM8.021 13.75h3.208c.367 0 .688.32.688.688 0 .366-.321.687-.688.687H8.021a.705.705 0 0 1-.688-.688c0-.366.321-.687.688-.687Zm9.625 4.583H8.02a.705.705 0 0 1-.688-.687c0-.367.321-.688.688-.688h9.625c.366 0 .687.321.687.688 0 .366-.32.687-.687.687Zm0-3.208h-3.209a.705.705 0 0 1-.687-.688c0-.366.32-.687.688-.687h3.208c.366 0 .687.32.687.688 0 .366-.32.687-.687.687Z"
      })
    ], -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "shipu"}) } }